import { ElementType } from 'react';
import { Form } from 'antd';
import { useTranslate } from '@tolgee/react';
import ShippingDays, { MultipleShippingDays } from 'views/BootGuide/views/AiModel/ShippingDays';
import TransitDays from 'views/BootGuide/views/AiModel/TransitDays';
import ShipPlace from 'views/BootGuide/views/AiModel/ShipPlace';
import SendPhotoBeforeShipping from 'views/BootGuide/views/AiModel/SendPhotoBeforeShipping';
import SpecifyExpressType from 'views/BootGuide/views/AiModel/SpecifyExpressType';
import CombinedShipping from 'views/BootGuide/views/AiModel/CombinedShipping';
import FreeShipping from 'views/BootGuide/views/AiModel/FreeShipping';
import ProvideInvoice from 'views/BootGuide/views/AiModel/ProvideInvoice';
import DropsShipping from 'views/BootGuide/views/AiModel/DropsShipping';
import PickUp from 'views/BootGuide/views/AiModel/PickUp';
import ServiceWorkingTime from 'views/BootGuide/views/AiModel/ServiceWorkingTime';
import Warranty from 'views/BootGuide/views/AiModel/Warranty';
import ShelfLife from 'views/BootGuide/views/AiModel/ShelfLife';
import PrivateShipping from 'views/BootGuide/views/AiModel/PrivateShipping';
import Gift from 'views/BootGuide/views/AiModel/Gift';
import { combineStoreScopes, UnConfigStore } from 'views/BootGuide/views/AiModel/share';
import { useUpdateEffect } from 'ahooks';
import useSmartField from 'hooks/useSmartField';
import { useLabel, useLLM } from '@knowledge/common/hooks/useGroup';
import { isNeedSliceStoreKnowledgeType } from '@knowledge/knowledges/general/utils';
import Wholesale from 'views/BootGuide/views/AiModel/Wholesale';

const RenderMap: Record<Knowledge.KnowledgeType, ElementType> = {
  LOGISTICS_SEND_OUT_TIME: MultipleShippingDays,
  LOGISTICS_DELIVERED_IN_TIME: TransitDays,
  LOGISTICS_SEND_OUT_PLACE: ShipPlace,
  LOGISTICS_SEND_PICTURES_BEFORE: SendPhotoBeforeShipping,
  LOGISTICS_DELIVERY_COURIER_TYPE: SpecifyExpressType,
  LOGISTICS_CONSOLIDATED_MULTIPLE_ORDER: CombinedShipping,
  SHOP_FREE_SHIPPING: FreeShipping,
  SHOP_INVOICE: ProvideInvoice,
  SHOP_DROPSHIPPING: DropsShipping,
  SHOP_PICKUP_AT_HOME: PickUp,
  SHOP_CUSTOMER_SERVICE_WORKING_TIME: ServiceWorkingTime,
  ITEM_WARRANTY_SERVICE: Warranty,
  ITEM_EXPIRATION_DATE: ShelfLife,
  OTHER_PRIVATE_SHIPPING: PrivateShipping,
  OTHER_GIFT: Gift,
  SHOP_WHOLESALE: Wholesale,
};

type KnowledgeTypeRendererProps = {
  type: Knowledge.KnowledgeType;
  fieldNamePrefix?: string;
  storeMap: Partial<Record<number, UnConfigStore>>;
  singleMode?: boolean;
};

function KnowledgeTypeRenderer(props: KnowledgeTypeRendererProps) {
  const { type, fieldNamePrefix, storeMap, singleMode } = props;
  const { t } = useTranslate();

  const LLM = useLLM();

  const Component = type === 'LOGISTICS_SEND_OUT_TIME' && !LLM ? ShippingDays : RenderMap[type];

  const getFieldName = (name: string) => (fieldNamePrefix ? `${fieldNamePrefix}.${name}` : name);

  const {
    field: { value: conditions },
  } = useSmartField<any>(getFieldName('conditions'));
  const {
    field: { value, onChange },
  } = useSmartField<any>(getFieldName('adaptValue'));

  useUpdateEffect(() => {
    if (!isNeedSliceStoreKnowledgeType(type)) {
      const storeScopes = combineStoreScopes(
        conditions.map((condition: any) => condition.storeScope.storeScope),
      );
      onChange({
        ...value,
        storeScopes,
      });
    }
  }, [conditions, type]);

  const { knowledgeLabel } = useLabel();

  const content = Component && (
    <Component singleMode={singleMode} prefix={getFieldName('adaptValue')} storeMap={storeMap} />
  );

  if (type === 'LOGISTICS_SEND_OUT_TIME' && !singleMode) {
    return content;
  }

  return (
    <Form>
      <Form.Item
        required={!singleMode}
        label={singleMode ? knowledgeLabel[type] : t('refundSetting.请选择')}
      >
        {content}
      </Form.Item>
    </Form>
  );
}

export default KnowledgeTypeRenderer;
